import {
  latitudeValidator,
  longitudeValidator,
  numericValidator,
  uniqueValidator,
} from 'functions/validation';
import colorValidator from './color_validator';

const validatorFromName = (validatorName) => {
    
    if (validatorName === 'latitude') {
      const retFunc = (args) => {
        return latitudeValidator(args);
      }
      return retFunc
    }
  
    else if (validatorName === 'longitude') {
      const retFunc = (args) => {
        return longitudeValidator(args);
      }
      return retFunc
    }
  
    else if (validatorName === 'unique') {
      const retFunc = (args) => {
        return uniqueValidator(args);
      }
      return retFunc
    }
  
    else if (validatorName === 'numeric') {
      const retFunc = (args) => {
        return numericValidator(args)
      }
      return retFunc
    }

    else if (validatorName === 'color') {
      const retFunc = (args) => {
        return colorValidator(args)
      }
      return retFunc
    }

    else if (validatorName === 'non-negative') {
      const retFunc = (args) => {
        args['requireNonNegative'] = true;
        return numericValidator(args)
      }
      return retFunc      
    }

    else if (validatorName === 'non-negative integer') {
      const retFunc = (args) => {
        args['requireInteger'] = true;
        args['requireNonNegative'] = true;
        return numericValidator(args)
      }
      return retFunc      
    }
  
    else {
      const retFunc = () => {
        return {valid:true}
      }
      return retFunc
    }
}

export default validatorFromName;